import React from "react";
import {Link} from "gatsby";

export default function NavLink(props) {
  const {className, ...rest} = props;
  return <Link className={`${className || ""} nav-link`}  {...rest}></Link>
}